module.exports = __webpack_public_path__ + "img/L_3C.8da3d231.png";